<template>
<!-- d-none d-md-block-->
  <div class="section section-about">
    <div class="container">
      <div class="row">
        <div class="col-md-10 ml-auto col-xl-6 mr-auto">
          
         <img
              v-lazy="myTheme.about_section_left_image"
              alt="Circle Image"
              class="rounded"
            />
          
        </div>
        <div class="col-md-10 ml-auto col-xl-6 mr-auto">
     
        <h1 :style="{'color' : myTheme.primaryTextColor + ' !important'}">{{ $t("text.welcome_to") }} </h1>
        <p class="title" :style="{'color' : myTheme.primaryTextColor + ' !important'}" >{{business.name}}</p>
        <p class="description" :style="{'color' : myTheme.secondaryTextColor + ' !important'}">
            {{business.description}}
        </p>
        
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'about-section',
};
</script>